"use strict";

function openPositiveVideo(event) {
  var modal = document.getElementById('js-modal-video-ad-positive');
  var video = modal.querySelector('video');
  video.play();
  modal.classList.add('is-open');
}

function closePositiveModal(id) {
  var modal = document.getElementById(id);
  var video = modal.querySelector('video');
  modal.classList.remove('is-open');
  video.pause();
  video.currentTime = 0;
}

function toggleModal(id) {
  var modal = document.getElementById(id);
  modal.classList.toggle('is-open');
}